import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-table tw-mx-auto tw-text-left"
}
const _hoisted_2 = { class: "first-letter:tw-uppercase" }
const _hoisted_3 = { class: "tw-text-right" }
const _hoisted_4 = { class: "tw-text-right" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { colspan: "2" }
const _hoisted_7 = { class: "tw-text-right" }
const _hoisted_8 = { class: "tw-font-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "Total", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_11 = { class: "tw-text-right" }
const _hoisted_12 = {
  key: 1,
  class: "sf-table tw-mx-auto tw-text-left"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "Your Reference", -1)
const _hoisted_15 = {
  class: "tw-text-right",
  colspan: "2"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "tw-text-right" }
const _hoisted_18 = { class: "tw-text-right" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "tw-text-right" }
const _hoisted_21 = { class: "tw-text-right" }
const _hoisted_22 = {
  key: 1,
  class: "tw-font-bold"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "Total cost before VAT", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_25 = { class: "tw-text-right" }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "tw-text-right" }
const _hoisted_28 = { class: "tw-text-right" }
const _hoisted_29 = { class: "tw-font-bold" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, "Total", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_32 = { class: "tw-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mode == 'individual')
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseData.products, (p, k) => {
            return (_openBlock(), _createElementBlock("tr", { key: k }, [
              _createElementVNode("td", _hoisted_2, _toDisplayString(p.label || _ctx.getLabel(p.name)), 1),
              _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.$filters.longDateFormat(p.period.start, false)) + " to " + _toDisplayString(_ctx.$filters.longDateFormat(p.period.end, false)), 1),
              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$filters.renderMoney(p.total)), 1)
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseData.discounts, (d, k) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
              (d.total > 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.getLabel(d.name)), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$filters.renderMoney(d.total)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _createElementVNode("tr", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$filters.renderMoney(_ctx.purchaseData.total)), 1)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("table", _hoisted_12, [
        _createElementVNode("tbody", null, [
          (_ctx.schoolReference)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.schoolReference), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseData.products, (item, k) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
              (item.count + item.total > 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.getLabel(item.name)), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(item.count) + " x " + _toDisplayString(_ctx.$filters.renderMoney(item.cost)), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$filters.renderMoney(item.total)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseData.discounts, (item, k) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
              (item.count + item.total > 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.getLabel(item.name)), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(item.count) + " x " + _toDisplayString(_ctx.$filters.renderMoney(item.discount)), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.$filters.renderMoney(item.total)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_ctx.purchaseData.tax)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$filters.renderMoney(_ctx.purchaseData.subtotal)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.purchaseData.tax)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                _createElementVNode("td", null, _toDisplayString(_ctx.purchaseData.tax.name), 1),
                _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.$filters.renderPercent(_ctx.purchaseData.tax.value)), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.$filters.renderMoney(_ctx.purchaseData.taxTotal)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tr", _hoisted_29, [
            _hoisted_30,
            _hoisted_31,
            _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.$filters.renderMoney(_ctx.purchaseData.total)), 1)
          ])
        ])
      ]))
}